import axios from './axios'
import config from '../config'

export default {
    getStatData(params) {
        return axios({
            url: config.backendUrl + '/common/stat-section/data',
            method: 'GET',
            params
        })
    },
    search(params) {
        return axios({
            url: config.backendUrl + '/common/stat-section/search',
            method: 'GET',
            params
        })
    },
}
